













import { Component, Watch, Vue, Emit } from 'vue-property-decorator';

@Component
export default class LinePointTime extends Vue {
  private visible = false;

  private patrolStartTime: any = '';
  private patrolEndTime: any = '';
  private data: any = {};
  private index: any = -1;

  /**
   * 窗口标题
   * @Params
   * @return
   **/
  get title() {
    return '设置时间';
  }

  /**
   * 打开窗口
   * @Params
   * @return
   **/
  async showDialog(data: any, index: any) {
    this.data = data;
    this.index = index;
    this.visible = true;
  }

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.patrolEndTime = '';
    this.patrolStartTime = '';
    this.visible = false;
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    let flag: any = true;
    this.data.timeInfo.forEach((item: any, index: any) => {
      if (item.startTime < this.patrolEndTime && item.startTime >= this.patrolStartTime) {
        flag = false;
      } else if (item.endTime > this.patrolStartTime && item.endTime <= this.patrolEndTime) {
        flag = false;
      } else if (item.startTime <= this.patrolStartTime && item.endTime >= this.patrolEndTime) {
        if (this.patrolEndTime > this.patrolStartTime) flag = false;
      }
    });
    if (this.patrolStartTime === '' || this.patrolEndTime === '' || this.patrolStartTime === null || this.patrolEndTime === null) {
      this.$confirm('巡检时间段不允许为空', '提示', {
        confirmButtonText: '我知道了',
        showCancelButton: false,
        type: 'warning',
      })
        .then(() => {})
        .catch(() => {});
      return;
    }
    if (flag) {
      this.data.timeInfo.push({
        startTime: this.patrolStartTime,
        endTime: this.patrolEndTime,
      });
    } else {
      this.$confirm('巡检时间段不允许交叉', '提示', {
        confirmButtonText: '我知道了',
        showCancelButton: false,
        type: 'warning',
      })
        .then(() => {})
        .catch(() => {});
    }
    this.hideDialog();
  }

  /**
   * 【广播】广播提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {}
}
